$(document).ready(function() {
  var metafield = $('.t4s-tab-wrapper').data('id-symbol-fmp') || "";
  var param;  
  if (metafield.trim() !== "") {param = metafield;} 
  else {param = document.URL.split("products/")[1].split("?")[0].toUpperCase();}  
    $.getJSON('https://financialmodelingprep.com/api/v3/key-metrics-ttm/'+param+'?apikey=3ccf620ce9315de8a4996e601373f716', function(data){
      $.each(data, function(i, elem){

/*Total Valuation*/
        
         if (elem.marketCapTTM == null) {var stat_marketcap_var = 'n/a';} else
         {var stat_marketcap_var = nFormatter(elem.marketCapTTM, 2);}
         $('#stat_marketcap').append(stat_marketcap_var);
         $('#stat_marketcap2').append(stat_marketcap_var);

         if (elem.enterpriseValueTTM == null) {var stat_entvalue_var = 'n/a';} else
         {var stat_entvalue_var = nFormatter(elem.enterpriseValueTTM, 2);}
         $('#stat_entvalue').append(stat_entvalue_var);
         $('#stat_entvalue2').append(stat_entvalue_var);

/*Enterprise Valuation*/

         if (elem.evToSalesTTM == null) {var evToSalesTTM_var = 'n/a';} else
         {var evToSalesTTM_var = nFormatter(elem.evToSalesTTM, 2);}
         $('#stat_evtosales').append(evToSalesTTM_var);

         if (elem.enterpriseValueOverEBITDATTM == null) {var enterpriseValueOverEBITDATTM_var = 'n/a';} else
         {var enterpriseValueOverEBITDATTM_var = nFormatter(elem.enterpriseValueOverEBITDATTM, 2);}
         $('#stat_evtoebitda').append(enterpriseValueOverEBITDATTM_var);
         $('#stat_evtoebitda2').append(enterpriseValueOverEBITDATTM_var);

         if (elem.evToOperatingCashFlowTTM == null) {var evToOperatingCashFlowTTM_var = 'n/a';} else
         {var evToOperatingCashFlowTTM_var = nFormatter(elem.evToOperatingCashFlowTTM, 2);}
         $('#stat_evtoebit').append(evToOperatingCashFlowTTM_var);
        
         if (elem.evToFreeCashFlowTTM == null) {var evToFreeCashFlowTTM_var = 'n/a';} else
         {var evToFreeCashFlowTTM_var = nFormatter(elem.evToFreeCashFlowTTM, 2);}
         $('#stat_evtofcf').append(evToFreeCashFlowTTM_var);        
         $('#stat_evtofcf2').append(evToFreeCashFlowTTM_var);                

/*Financial Position*/

         if (elem.debtToEquityTTM == null) {var debtToEquityTTM_var = 'n/a';} else
         {var debtToEquityTTM_var = nFormatter(elem.debtToEquityTTM, 2);}
         $('#stat_debt_equity').append(debtToEquityTTM_var);        
         $('#stat_debt_equity2').append(debtToEquityTTM_var);                

/*Financial Efficiency*/

         if (elem.roicTTM == null) {var roicTTM_var = 'n/a';} else
         {var roicTTM_var = elem.roicTTM.toLocaleString('en-US', {style: 'percent', minimumFractionDigits:2});}
         $('#stat_return_on_capital_roic').append(roicTTM_var);
         $('#stat_return_on_capital_roic2').append(roicTTM_var);        

         if (elem.inventoryTurnoverTTM == null) {var inventoryTurnoverTTM_var = 'n/a';} else
         {var inventoryTurnoverTTM_var = nFormatter(elem.inventoryTurnoverTTM, 2);}
         $('#stat_inventory_turnover').append(inventoryTurnoverTTM_var);        

/*Dividends & Yields*/

         if (elem.dividendPerShareTTM == null) {var dividendPerShareTTM_var = 'n/a';} else
         {var dividendPerShareTTM_var = nFormatter(elem.dividendPerShareTTM, 2);}
         $('#stat_dividend_per_share').append(dividendPerShareTTM_var);        
         $('#stat_dividend_per_share2').append(dividendPerShareTTM_var);                
        
         if (elem.dividendYieldTTM == null) {var dividendYieldTTM_var = 'n/a';} else
         {var dividendYieldTTM_var = elem.dividendYieldTTM.toLocaleString('en-US', {style: 'percent', minimumFractionDigits:2});}
         $('#stat_dividend_yield').append(dividendYieldTTM_var);
         $('#stat_dividend_yield2').append(dividendYieldTTM_var);        

         if (elem.earningsYieldTTM == null) {var earningsYieldTTM_var = 'n/a';} else
         {var earningsYieldTTM_var = elem.earningsYieldTTM.toLocaleString('en-US', {style: 'percent', minimumFractionDigits:2});}
         $('#stat_earnings_yield').append(earningsYieldTTM_var);

         if (elem.freeCashFlowYieldTTM == null) {var freeCashFlowYieldTTM_var = 'n/a';} else
         {var freeCashFlowYieldTTM_var = elem.freeCashFlowYieldTTM.toLocaleString('en-US', {style: 'percent', minimumFractionDigits:2});}
         $('#stat_fcf_yield').append(freeCashFlowYieldTTM_var);

         if (elem.payoutRatioTTM == null) {var payoutRatioTTM_var = 'n/a';} else
         {var payoutRatioTTM_var = elem.payoutRatioTTM.toLocaleString('en-US', {style: 'percent', minimumFractionDigits:2});}
         $('#stat_payout_ratio').append(payoutRatioTTM_var);

/*Balance Sheet*/

         if (elem.bookValuePerShareTTM == null) {var bookValuePerShareTTM_var = 'n/a';} else
         {var bookValuePerShareTTM_var = nFormatter(elem.bookValuePerShareTTM, 2);}
         $('#stat_book_value_per_share').append(bookValuePerShareTTM_var);        

         if (elem.workingCapitalTTM == null) {var workingCapitalTTM_var = 'n/a';} else
         {var workingCapitalTTM_var = nFormatter(elem.workingCapitalTTM, 2);}
         $('#stat_working_capital').append(workingCapitalTTM_var);        

        

/*Cash Flow*/

         if (elem.freeCashFlowPerShareTTM == null) {var freeCashFlowPerShareTTM_var = 'n/a';} else
         {var freeCashFlowPerShareTTM_var = nFormatter(elem.freeCashFlowPerShareTTM, 2);}
         $('#stat_fcf_per_share').append(freeCashFlowPerShareTTM_var);        
        
        
      });
    })
});